// import Vue from 'vue'
import * as types from '../mutation-types'
import { api } from '@/modules/api/index'
import { assocPath, pathOr, compose, path } from 'ramda'

import preparePayload from '@/utils/preparePayload'

const state = {
  currentForm: {}
}

const getters = {
  currentForm: state => state.currentForm,
  getInstructionsSettings: state => pathOr({}, ['metadata', 'instructions'], state.currentForm),
  getButtonSettings: state => pathOr({}, ['metadata', 'button'], state.currentForm),
  getErrorsSettings: state => pathOr({}, ['metadata', 'errors'], state.currentForm),
  getMessageSettings: state => pathOr({}, ['metadata', 'messages'], state.currentForm),
  getSubmitModalSettings: state => pathOr({}, ['metadata', 'submitModal'], state.currentForm)
}

const actions = {
  async getFormByType ({ commit }, type) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.form.getFormByType(type))
      commit(types.SAVE_CURRENT_FORM, response.data.form)
    } catch (e) {
      this.dispatch('showResultErrorMessage')
      console.log(e)
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateForm ({ getters, commit }, payload) {
    const config = {
      instructions: ['metadata', 'instructions'],
      thankYouPage: ['metadata', 'thankYouPage'],
      errors: ['metadata', 'errors'],
      messages: ['metadata', 'messages'],
      submitModal: ['metadata', 'submitModal'],
      button: ['metadata', 'button'],
      fields: ['fields']
    }
    const {filterEmptyStrings, filterNull} = preparePayload

    try {
      commit(types.SET_SPINNER_STATUS, true)
      let filterForm = compose(filterEmptyStrings, filterNull)
      let newForm = filterForm(Object.keys(payload).reduce((newForm, formKey) => {
        return assocPath(config[formKey], payload[formKey], newForm)
      }, getters.currentForm))
      const res = await this.$axios.put(api.formConstuctor.update(), newForm)
      if (res.status < 400) {
        commit(types.SAVE_CURRENT_FORM, newForm)
        this.dispatch('showResultSuccessMessage', 'Saved')
      } else {
        this.dispatch('showResultErrorMessage')
      }
    } catch (err) {
      if (!payload.fields.length) {
        this.dispatch('showResultErrorMessage', 'Form cannot contain less than one field. It will not work correctly')
      } else if (err.response.data.Code === 'validation.base-0001') {
        this.dispatch('showResultErrorMessage', path(['response', 'data', 'Message'], err) + '. ' + path(['response', 'data', 'ValidationFailures', '0', 'errorMessage'], err))
      } else {
        this.dispatch('showResultErrorMessage', err.response.data.Message)
      }
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SAVE_CURRENT_FORM] (state, form) {
    state.currentForm = form
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/currentForm.js